import React, { useState } from "react";
import { Table } from "antd";
import { useSelector } from "react-redux";
import { FileImageOutlined } from "@ant-design/icons";

import MenuConfigurationCategoriesEditModal from "./MenuConfigurationCategoriesEditModal";

const MenuConfigurationCategoriesTable = ({
  filterTable,
  categoriesDataSource,
}) => {
  const { categories, syncImageInProgress } = useSelector(
    (state) => state.menuConfigurationReducer
  );
  const [record, setRecord] = useState({});
  const [openCategoryEditModal, setOpenCategoryEditModal] = useState(false);
  const columns = [
    {
      title: "Име",
      dataIndex: "name",
      key: "name",
      sorter: (a, b) => a?.name?.localeCompare(b?.name),
      width: window.innerWidth < 760 && "100px",
    },
    {
      title: "Сорт Индекс",
      dataIndex: "sortIndex",
      key: "sortIndex",
      width: window.innerWidth < 760 && "100px",
    },
    {
      title: "Снимка",
      dataIndex: "picture",
      key: "picture",
      width: window.innerWidth < 760 && "100px",
      align: "center",
      render: (text, record) => {
        if (record.imagePath) {
          return (
            <img
              style={{ width: "30px" }}
              src={record.imagePath}
              alt="category"
            />
          );
        } else {
          return (
            <FileImageOutlined style={{ fontSize: "25px", padding: "5px 0" }} />
          );
        }
      },
    },
  ];

  function replaceKeyRecursive(obj, oldKey, newKey) {
    if (Array.isArray(obj)) {
      obj.sort((a, b) => {
        // If sortIndex is 0, move it to the end
        if (a.sortIndex === 0 && b.sortIndex !== 0) {
          return 1;
        } else if (a.sortIndex !== 0 && b.sortIndex === 0) {
          return -1;
        } else {
          // Otherwise, sort by sortIndex in ascending order
          return a.sortIndex - b.sortIndex;
        }
      });

      return obj.map((item) => replaceKeyRecursive(item, oldKey, newKey));
    } else if (typeof obj === "object" && obj !== null) {
      const newObj = {};
      for (let key in obj) {
        if (key === oldKey) {
          newObj[newKey] = replaceKeyRecursive(obj[key], oldKey, newKey);
        } else {
          newObj[key] = replaceKeyRecursive(obj[key], oldKey, newKey);
        }
      }
      return newObj;
    } else {
      return obj;
    }
  }

  // Replace subCategories with children for And Design Table component
  const data = replaceKeyRecursive(
    filterTable === null ? categoriesDataSource : filterTable,
    "subCategories",
    "children"
  );

  return (
    <>
      <Table
        className="menu-configuration-categories-table"
        loading={categories.length === 0 || syncImageInProgress}
        dataSource={data}
        pagination={{
          defaultPageSize: 50,
          showSizeChanger: true,
          pageSizeOptions: ["10", "25", "50", "100"],
        }}
        size="small"
        rowKey="id"
        columns={columns}
        onRow={(record) => ({
          onClick: () => {
            setRecord(record);
            setOpenCategoryEditModal(true);
          },
        })}
      />

      <MenuConfigurationCategoriesEditModal
        record={record}
        openCategoryEditModal={openCategoryEditModal}
        setOpenCategoryEditModal={setOpenCategoryEditModal}
      />
    </>
  );
};

export default MenuConfigurationCategoriesTable;
